import React from 'react'
import { PageContentWrapper } from '../../components/LayoutContainer.ui'
import { NAME } from '../../data/appVariables'
import PublicNav from './components/PublicNavbar'
import styled from '@emotion/styled/macro'
import { ReactComponent as Logo } from '../../huddles.svg'
import Button from '../../components/Button'
import { Link } from 'react-router-dom'
import Card from '../../components/Card.ui'
import { ReactComponent as TeamIcon } from '../../assets/icons/team.svg'
import { ReactComponent as PitchIcon } from '../../assets/icons/pitch.svg'
import { useUser } from '../../data/user'
const HeroSection = styled('div')`
    height: fit-content;
    padding: 3rem;
    background: var(--colors-grays-0);
    display: flex;
    /* justify-content: center; */
    /* align-items: center; */
    flex-direction: column;
    @media (max-width: 768px) {
        border-radius: 0;
    }
`
const HeroCard = styled(HeroSection)`
    background: var(--colors-grays-20);
    margin-top: 1rem;
    border: var(--borders-main);
    /* border-radius: var(--borderRadius-xl); */
`
const DarkHero = styled(HeroSection)`
    background: var(--colors-grays-80);
    > * {
        color: var(--colors-grays-20);
    }
`
const LayoutContainer = styled('div')`
    overflow: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`
const Footer = styled('div')`
    font-size: 0.75rem;
    width: 100vw;
    margin-bottom: 0;
    box-sizing: border-box;
    background: var(--colors-grays-80);
    color: var(--colors-grays-20);
    padding: 0.5rem;
    > * {
        color: var(--colors-grays-60);
    }
`
const SmartPhone = styled('div')`
    width: 300px;
    height: 600px;
    border: 5px solid var(--colors-grays-80);
    border-radius: 20%;
`
const LandingPage = () => {
    const [{ activeUser }] = useUser()
    return (
        <LayoutContainer>
            <PageContentWrapper style={{ marginBottom: 0, marginTop: 0 }}>
                <PublicNav />
                <div
                    style={{
                        height: 'fit-content',
                        width: '100%',
                        maxWidth: '20rem',
                    }}
                >
                    <Logo />
                </div>
                <HeroCard>
                    <PitchIcon
                        style={{ alignSelf: 'center', maxWidth: '12rem' }}
                    />
                    <h2>Manage your football club better!</h2>
                    <p>
                        {NAME} is an app that makes it easier for players and
                        teams to work together and organize events, such as
                        matches and trainings
                    </p>
                    <Button
                        as={Link}
                        to={activeUser ? '/my/user' : '/signup'}
                        style={{ width: 'fit-content', minWidth: '10rem' }}
                    >
                        {activeUser ? 'Go to my page' : 'Get started'}
                    </Button>
                </HeroCard>
            </PageContentWrapper>
            <Footer>
                ©{new Date().getFullYear()} Huddles{' -  '}
                <Link to="/privacy">Privacy Policy</Link>
            </Footer>
        </LayoutContainer>
    )
}

export default LandingPage
